import {combineLatest} from 'rxjs';
import {throttleTime, map, startWith, shareReplay} from 'rxjs/operators';
import {positionsCacheAll$} from './positions-cache-all';
import {contractMarketRealtimeCache$} from '@/market-contract/market24h-contract-cache';
import {contractDefaultTakerFeeRateEr$, contractsCache$, leverageMarginsCache$} from '@/config';
import {type AccountPosTotalData, calcPostTotalData} from '../calc';

export const accountPosTotalDataCacheAll$ = combineLatest([
  positionsCacheAll$,
  contractMarketRealtimeCache$,
  contractsCache$,
  leverageMarginsCache$,
  contractDefaultTakerFeeRateEr$,
]).pipe(
  throttleTime(500),
  map(
    ([
      positionsCacheAll,
      contractMarketRealtimeCache,
      contractsCache,
      leverageMarginsCache,
      contractDefaultTakerFeeRateEr,
    ]) => {
      const cache = new Map();
      positionsCacheAll.forEach((val, key) => {
        cache.set(
          key,
          calcPostTotalData([
            val,
            contractMarketRealtimeCache,
            contractsCache,
            leverageMarginsCache,
            contractDefaultTakerFeeRateEr,
          ])
        );
      });
      return cache;
    }
  ),
  startWith(new Map<number, Map<string, AccountPosTotalData>>()),
  shareReplay(1)
);
